import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { onFapiaoCancelled } from '../actions';
import PaddleInvoices from './PaddleInvoices';
var mapStateToProps = function mapStateToProps(_ref) {
  var curie = _ref.curie;
  return {
    paddleInvoices: curie.paddleInvoices
  };
};
var mapDispatchToProps = {
  onFapiaoCancelled: onFapiaoCancelled
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaddleInvoices));